export default "__VITE_ASSET__58bc5887__"